import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import classnames from "classnames";
import _ from "i18n";

import { createdDateFormat } from "Utils";
import { selectCurrentOrganization } from "Selectors";
import Slide from "../Dashboard/Slide";
import LegalFormsList from "./LegalFormsList";
import { ICONS, SvgIcon } from "../Common/Icons";

import styles from "./Item.local.scss";
import { getLabelsByLng } from "../../utils";

class Item extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isHovering: false
    };
  }
  handleMouseOver = () => {
    this.setState({ isHovering: true });
  };
  handleMouseOut = () => {
    this.setState({
      isHovering: false
    });
  };
  render() {
    let { lng, dashboard, toApprove } = this.props;
    let legalforms = this.props.dashboard.legalForms.split(",");

    return (
      <div className={classnames("medium-4", styles.dashboard_mini_item)}>
        <ul style={{ display: "flex" }}>
          <li
            className={styles.dashboard_card}
            style={{ background: "#F8F9FA" }}
            onMouseOver={this.handleMouseOver}
            onMouseOut={this.handleMouseOut}
          >
            <div
              className={styles.dashboard_container}
              style={{ background: "#F8F9FA" }}
            >
              {dashboard.slides[0] && (
                <div className={styles.item}>
                  {dashboard.slides[2] ? (
                    <Slide
                      key={dashboard.slides[2].id}
                      slide={dashboard.slides[2]}
                      isResponsive={false}
                    />
                  ) : (
                    <div className={styles.hidden_slide}>
                      <Slide
                        key={dashboard.slides[0].id}
                        slide={dashboard.slides[0]}
                        isResponsive={false}
                      />
                    </div>
                  )}
                  {dashboard.slides[1] ? (
                    <Slide
                      key={dashboard.slides[1].id}
                      slide={dashboard.slides[1]}
                      isResponsive={false}
                    />
                  ) : (
                    <div className={styles.hidden_slide}>
                      <Slide
                        key={dashboard.slides[0].id}
                        slide={dashboard.slides[0]}
                        isResponsive={false}
                      />
                    </div>
                  )}
                  <Slide
                    key={dashboard.slides[0].id}
                    slide={dashboard.slides[0]}
                    isResponsive={false}
                  />
                </div>
              )}
            </div>

            <div
              className={classnames(
                styles.informations_container,
                this.state.isHovering && styles.information_icon
              )}
              style={{ background: "#FFFFFF" }}
            >
              <div>
                <div className={styles.information_bloc}>
                  <h2 className={styles.title}>
                    {getLabelsByLng(dashboard.labels, lng).length > 20 &&
                    !this.state.isHovering
                      ? getLabelsByLng(dashboard.labels, lng).substring(0, 15) +
                        " ..."
                      : getLabelsByLng(dashboard.labels, lng)}
                  </h2>
                  <div className={styles.date}>
                    <span>
                      {_("createdAt")}{" "}
                      {createdDateFormat(dashboard.createdAt, lng)} <br />
                    </span>
                    <span>
                      {dashboard.organization === "STANDARD"
                        ? _("standard")
                        : _("by") + " " + dashboard.organization}
                    </span>
                  </div>
                </div>
                <div className={styles.flags}>
                  {dashboard.labels.fr.length > 0 && (
                    <img src="/img/icons/fr_flag.svg" alt="" />
                  )}
                  {dashboard.labels.nl.length > 0 && (
                    <img src="/img/icons/nl_flag.svg" alt="" />
                  )}
                  {dashboard.labels.en.length > 0 && (
                    <img src="/img/icons/en_flag.svg" alt="" />
                  )}
                </div>
                <div className={styles.status}>
                  {dashboard.isPublic === true ? (
                    <div className={styles.tags}>
                      <SvgIcon
                        icon={ICONS.Share}
                        className={styles.statusIcon}
                      />
                      <span>{_("share")}</span>
                    </div>
                  ) : (
                    <div className={styles.tags}>
                      <SvgIcon
                        icon={ICONS.Lock}
                        className={styles.statusIcon}
                      />
                      <span>{_("private")}</span>
                    </div>
                  )}
                  {dashboard.isOriginal === true ? (
                    <div className={styles.tags}>
                      <SvgIcon
                        icon={ICONS.Original}
                        className={styles.statusIcon}
                      />
                      <span>{_("original")}</span>
                    </div>
                  ) : (
                    <div className={styles.tags}>
                      <SvgIcon
                        icon={ICONS.Duplicated}
                        className={styles.statusIcon}
                      />
                      <span>{_("duplicated")}</span>
                    </div>
                  )}
                  <span className={classnames(styles.tags, styles.slidesCount)}>
                    {dashboard.nbSlides}
                    {""} {_("slide")}
                  </span>

                  <div
                    className={styles.flex_container}
                    style={{ display: !this.state.isHovering && "none" }}
                  >
                    <LegalFormsList legalForms={legalforms} />
                  </div>

                  <div
                    className={styles.more_information}
                    style={{ display: !this.state.isHovering && "none" }}
                  >
                    <div className={styles.actions_container}>
                      <div>
                        <div>
                          <div
                            className={classnames(
                              "d-flex align-items-center justify-content-center",
                              styles.actions,
                              getLabelsByLng(dashboard.labels, lng).length > 50
                                ? styles.action_position
                                : styles.action_position_hover
                            )}
                          >
                            <div
                              onClick={() =>
                                this.props.displayDashboardSlides(dashboard)
                              }
                            >
                              <SvgIcon icon={ICONS.LOOP_ICON} className={""} />
                            </div>
                            {!toApprove ? (
                              <Fragment>
                                <div
                                  onClick={() =>
                                    this.props.selectDashboard(dashboard)
                                  }
                                >
                                  <SvgIcon
                                    icon={ICONS.SIMPLE_PLUS_ICON}
                                    className={""}
                                  />
                                </div>
                              </Fragment>
                            ) : (
                              <Fragment>
                                <div
                                  onClick={() => this.props.onCancelDashboard()}
                                >
                                  <SvgIcon
                                    icon={ICONS.SIMPLE_PLUS_ICON}
                                    className={styles.close_icone}
                                  />
                                </div>
                              </Fragment>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  lng: state.params.lng,
  backOffice: state.params.backOffice,
  preferences: state.auth.preferences,
  currentOrganization: selectCurrentOrganization(state)
});

export default connect(mapStateToProps)(Item);



// WEBPACK FOOTER //
// ./src/components/DashboardList/MiniItem.js